<script>
import { mapActions } from "vuex";
import InfiniteAutocomplete from "./InfiniteAutocomplete.vue";

/**
 * 自社処分事業者・事業場選択コンポーネント
 *
 */
export default {
  name: "InfiniteTraderLocationAutoComplete",
  components: {
    InfiniteAutocomplete,
  },
  props: {
    /**
     * 事業者ID
     */
    traderId: {
      type: Number,
      default: null,
    },
    /**
     * 事業者種別
     */
    traderType: {
      type: String,
      default: null,
    },
    /**
     * 事業場ID
     */
    locationId: {
      type: Number,
      default: null,
    },
    label: {
      type: String,
      default: "事業場",
    },
    required: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    rounded: {
      type: Boolean,
      default: false,
    },
    classes: {
      type: String,
      default: null,
    },
    /**
     * 展開する種別
     * transport: 運搬業者
     * trader: 処分業者
     * either: 運搬・処分両方
     */
    searchType: {
      type: String,
      default: "transport",
      validator(val) {
        return ["transport", "trader", "either"].includes(val);
      },
    },
    withoutInvisible: {
      type: Boolean,
      default: false,
    },
    withoutNoneReporting: {
      type: Boolean,
      default: false,
    },
    withoutNoneSubscribe: {
      type: Boolean,
      default: false,
    },
    choseOne: {
      type: Boolean,
      default: false,
    },
    ownDisposer: {
      type: Boolean,
      default: false,
    },
    withFinalDisposer: {
      type: Boolean,
      default: false,
    },
    /**
     * 再資源 許可番号登録済のみ(報告不要, 未加入に適用する条件)
     */
    permitNumberRegisteredOnly: {
      type: Boolean,
      default: false,
    },

  },
  data() {
    return {
      loading: false,
      searchKeyword: null,
      timerId: undefined,
      pageNumber: 0,
      locations: [],
      pagination: {
        next_page: null,
        prev_page: null,
        is_first_page: false,
        is_last_page: false,
      },
      workableId: null,
      workableCode: null,
    };
  },
  computed: {},
  watch: {

    /**
     * 事業場IDの変更検知
     * @param newValue
     * @param oldValue
     */
    locationId(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.loadLocations(newValue);
      }
    },

    /**
     * 事業場コードの変更検知
     * @param newValue
     */
    locationCode(newValue) {
      this.workableCode = newValue;
    },

    /**
     * 事業者IDの変更検知
     */
    traderId(newValue, oldValue) {
      if (newValue !== oldValue) {
        if (newValue === null) {
          this.clearCallback();
        } else {
          this.reloadLocations();
        }
      }
    },

    /**
     * 作業用排出事業者IDの変更検知
     */
    workableId() {
      this.returnCurrentValues();
    },

    workableCode() {
      this.returnCurrentValues();
    }
  },
  /**
   * 画面ロード時に呼ばれる.
   * ここで初期設定などを行う.
   */
  created() {
    if (this.locationId) {
      this.workableId = this.locationId;
      this.loadLocations(this.workableId);
    } else {
      this.fetchLocationMembers();
    }
    if (this.locationCode) {
      this.workableCode = this.locationCode;
    }

  },

  methods: {
    ...mapActions("DriverMasterSearchTraderLocationMember", {
      fetchTraderLocations: "index",
    }),
    /**
     * 事業場チェンジ コールバック
     * ・事業者の再取得を行う
     */
    changeCallback(item) {
      this.workableId = item.id;
      this.workableCode = item.code;
    },
    /**
     * 事業場クリア コールバック
     */
    clearCallback() {
      this.workableCode = null;
      this.workableId = null;
      this.$emit("update:values", null);
      this.reloadLocations();
    },
    loadLocations(id) {
      const conditions = {
        search_type: this.searchType,
        target_id: id,
        trader_id: this.traderId,
        without_invisible: this.withoutInvisible,
        without_non_reporting: this.withoutNoneReporting,
        without_non_subscribe: this.withoutNoneSubscribe,
        own_disposer: this.ownDisposer,
        with_final_disposer: this.withFinalDisposer,
        permit_number_registered_only: this.permitNumberRegisteredOnly,
        page: 1,
      };
      this.fetchTraderLocations({ query: conditions }).then((response) => {
        this.locations = response.locations;
        if (this.choseOne && this.locations.length === 1) {
          this.workableId = this.locations[0].id;
          this.workableCode = this.locations[0].code;
        }
        this.pagination = response.pagination;
        this.pageNumber = response.pagination.current_page;
      });
    },
    resetLocations() {
      this.searchKeyword = null;
      this.pageNumber = 0;
      this.locations = [];
      Object.assign( this.$data.pagination, this.$options.data().pagination );
    },
    /**
     * 事業場 リロード処理
     */
    reloadLocations() {
      this.resetLocations();
      this.fetchLocationMembers();
    },

    /**
     * 排出事業場オプション取得アクション
     */
    fetchLocationMembers() {
      this.loading = true;
      const conditions = {
        search_type: this.searchType,
        trader_id: this.traderId,
        query: this.searchKeyword,
        without_invisible: this.withoutInvisible,
        without_non_reporting: this.withoutNoneReporting,
        without_non_subscribe: this.withoutNoneSubscribe,
        own_disposer: this.ownDisposer,
        with_final_disposer: this.withFinalDisposer,
        permit_number_registered_only: this.permitNumberRegisteredOnly,
        page: this.pageNumber,
      };

      this.fetchTraderLocations({ query: conditions }).then((response) => {
        this.locations = this.locations.concat(response.locations);
        if (this.choseOne && this.traderId && this.locations.length === 1) {
          this.workableId = this.locations[0].id;
          this.workableCode = this.locations[0].code;
        }

        this.pagination = response.pagination;
        this.pageNumber = response.pagination.current_page;
      })
        .finally(() => {
          this.loading = false;
        });
    },
    /**
     * 排出事業場
     * 次ページ読込
     */
    insectCallback() {
      if (this.pageNumber > 0) {
        this.pageNumber++;
        this.fetchLocationMembers();
      }
    },
    enterKeydownCallback (value) {
      this.pageNumber = 0;
      this.searchKeyword = value;
      this.fetchLocationMembers();
    },
    returnCurrentValues () {
      if (this.locations.length > 0) {
        const object = this.locations.find((location) => location.value === this.workableId);
        this.$emit("update:values", object);
      }
    },
  },
};
</script>
<template>
  <div>
    <validation-provider
      v-slot="{ errors }"
      :value="workableId"
      :rules="{ required: required }"
      :class="{ requiredMark: required }"
      :name="label"
    >
      <infinite-autocomplete
        v-model="workableId"
        :classes="classes"
        :disabled="disabled"
        :error-messages="errors"
        :label="label"
        :loading="loading"
        :members="locations"
        :pagination="pagination"
        :rounded="rounded"
        item-text="label"
        @change="changeCallback"
        @click:clear="clearCallback"
        @insect="insectCallback"
        @keydown:enter="enterKeydownCallback"
      >
        <template v-slot:prepend>
          <slot name="prepend" />
        </template>
        <template v-slot:prepend-inner>
          <slot name="prepend-inner" />
        </template>
        <template v-slot:selection="{ item }">
          <slot name="selection" v-bind:item="item">
            {{ item.text }}
          </slot>
        </template>
        <template v-slot:item="{ item }">
          <slot name="item" v-bind:item="item">
            {{ item.label }}
          </slot>
        </template>
        <template v-slot:append>
          <slot name="append" />
        </template>
        <template v-slot:append-outer>
          <slot name="append-outer" />
        </template>
      </infinite-autocomplete>
    </validation-provider>
  </div>
</template>
